import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=dc975c6a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc975c6a')) {
      api.createRecord('dc975c6a', component.options)
    } else {
      api.reload('dc975c6a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=dc975c6a&", function () {
      api.rerender('dc975c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2can4wr2GjZRW/JS/comp/FavElement.vue"
export default component.exports